<template>
  <div class="row justify-content-center">
    <div class="table-container">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Nome</th>
            <th>E-mail</th>
            <th>Data de Assinatura</th>
            <th>Status</th>
          </tr>
        </thead>
        <tr v-for="(userSent, userSentIndex) in signatureUserSent.signature_batch
                  .users_sent" :key="userSentIndex">
          <td>{{ userSent.user.name }}</td>
          <td>{{ userSent.user.email }}</td>
          <td>
            {{
              userSent.signed == 0
              ? "Não Assinado"
              : userSent.signed_at
            }}
          </td>
          <td>
            <font size="+0">
              <span class="badge" :class="[
                    userSent.status == 'done'
                      ? 'pastel-green'
                      : userSent.status == 'pending'
                        ? 'pastel-yellow'
                        : 'pastel-red',
                  ]">{{

      userSent.status == "done"
      ? "Concluído"
      : userSent.status == "pending"
        ? "Pendente"
        : userSent.status == "late"
          ? "Atrasado"
          : "Cancelado"
    }}</span>
            </font>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    signatureUserSent: Object
  },
}
</script>

<style scoped>
.table,
th,
td {
  border: 1px solid rgb(0, 0, 0);
}

.table-container {
  overflow-x: auto;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/SignatureUser/MultipleSignaturesTable.vue